import { isValidNumber } from 'libphonenumber-js';
import {has, each, cloneDeep} from 'lodash';
import moment from 'moment';
import { imageBasePath } from '../constants/staticData';

export function validateEmail(email) {
  const re = /^(.+)@(.+)\.(.+)$/i;
  // const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}
export function validateMobile(mobile) {
  // const mob = /^[+]*[0-9][+0-9]{11,14}$/;
  mobile = '+971' + mobile;
  return isValidNumber(mobile);
}

export function validateAlphaNumeric(textInput) {
  const re = /^[a-zA-Z0-9_-]*$/;
  return re.test(textInput);
}

export function validateAlphabets(textInput) {
  const re = /^[a-zA-Z]*$/;
  return re.test(textInput);
}
export function isNumeric(num) {
  return !isNaN(num);
}

export function validatePassword(inputValue) {
  let re = new RegExp(/^.{6,255}$/);
  return re.test(inputValue);
}
export function validateField(validationObj, value){
  if (validationObj && validationObj.validationType) {
    switch(validationObj.validationType) {
      case 'text': {
        let isValid = value && value.length ? true : false;
        if (validationObj.minLength) {
          isValid = value.length >= validationObj.minLength;
        }
        return isValid;
      }
      case 'numeric': {
        return isNumeric(value);
      }
      case 'alphanumeric': {
        if (validationObj.notMandatory) {
          if (value && value.length) {
            return validateAlphaNumeric(value);
          } else {
            return true;
          }
        } else {
          return validateAlphaNumeric(value);
        }
      }
      case 'alphabets': {
        if (validationObj.notMandatory) {
          if (value && value.length) {
            return validateAlphabets(value);
          } else {
            return true;
          }
        } else {
          return validateAlphabets(value);
        }
      }
      case 'email': {
        return validateEmail(value);
      }
      case 'mobile': {
        return validateMobile(value);
      }
      case 'password': {
        let isValid = value && value.length ? true : false;
        if (validationObj.minLength) {
          isValid = value.length >= validationObj.minLength;
        }
        return isValid;
      }
    case 'email/mobile': {
      if(isNumeric(value)){
        return validateMobile(value);
      } else {
        return validateEmail(value);
      }
    }
    }
  }
  return false;
}

export function validateFormSubmit(formData, errors) {
  let validForm = true;
  for (const key in formData) {
    if (has(errors, key)){
      if (!formData[key]) {
        errors[key] = true;
        validForm = false;
      } else if (errors[key]) {
        validForm = false;
      }
    }
  }
  return {'validForm': validForm, errors: errors};
}

export function testSpaces(inputValue){
  const val = inputValue || '';
  if (val && val.replace) {
    return val.replace(/\s/,"").length;
  } else {
    return false;
  }
}


export function windowWidth() {
    let docElemProp = window.document.documentElement.clientWidth,
        body = window.document.body;
    return window.document.compatMode === "CSS1Compat" && docElemProp || body && body.clientWidth || docElemProp;
}

export function decryptCookie(cookieString) {
  const cookie = unescape(cookieString);
  let output = {};
  cookie.split(/\s*;\s*/).forEach(function(pair) {
    pair = pair.split(/\s*=\s*/);
    output[pair[0]] = pair.splice(1).join('=');
  });
  return output;
}

export function timeSince(date) {
  let seconds = Math.floor((new Date() - date) / 1000);
  let interval = Math.floor(seconds / 31536000);

  if (interval > 1) {
    return interval + " y";
  }
  interval = Math.floor(seconds / 2592000);
  if (interval > 1) {
    return interval + " m";
  }
  interval = Math.floor(seconds / 86400);
  if (interval > 1) {
    return interval + " d";
  }
  interval = Math.floor(seconds / 3600);
  if (interval >= 1) {
    return interval + " h";
  }
  interval = Math.floor(seconds / 60);
  if (interval >= 1) {
    return interval + " min";
  }
  return Math.floor(seconds) + " s";
}

export function dateToTime(date){
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0'+minutes : minutes;
  let strTime = hours + ':' + minutes + ' ' + ampm;
  return strTime;
}

export function queryStringtoArray(Key) {
  let url = window.location.href;
  let KeysValues = url.split(/[\?&]+/);
  for (let i = 0; i < KeysValues.length; i++) {
    let KeyValue = KeysValues[i].split("=");
    if (KeyValue[0] == Key) {
      return KeyValue[1];
    }
  }
}

export function updateQueryStringParameter(uri, key, value) {
  let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  let separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  }
  else {
    return uri + separator + key + "=" + value;
  }
}

export function sumByObject(data, keyName) {
    console.log('Sum by Obj');
    let total = 0;
    each(data, (i) => {
      const value = Number(i[keyName]);
      if (value > 0) {
        total += Number(value);
      }
    });
    return total;
}

/* buffer = current time + buffer hours*/
export function checkDateTimeInvalid(buffer, selectedDate, selectedTime) {
  let allowedTime = moment().add('hours',1);
  if (selectedTime && selectedDate) {
    let newDate = selectedTime;
    newDate.set({'date': selectedDate.get('date'), 'month': selectedDate.get('month'), 'year': selectedDate.get('year')});
    if (newDate.isSameOrAfter(allowedTime)) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
}

export function isGreaterThanStartDate(endDate, endTime, startDate, startTime) {
  if (endTime && endDate) {
    let newStartDate = cloneDeep(startTime);
    let newEndDate = endTime;
    newStartDate.set({'date': startDate.get('date'), 'month': startDate.get('month'), 'year': startDate.get('year')});
    newEndDate.set({'date': endDate.get('date'), 'month': endDate.get('month'), 'year': endDate.get('year')});
    const allowedTime = newStartDate.add('hours', 1);
    if (newEndDate.isSameOrAfter(allowedTime)) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
}

export function defaultImageOnError() {
  return `${imageBasePath}/pic.png`;
} 



// WEBPACK FOOTER //
// ./src/helpers/index.js